import { useInfiniteQuery } from "@tanstack/react-query";
import { APIClient } from "../constants";
import { useWalletContext } from "../context/wallet";
import { IOrdItem } from "../types";

const LIMIT = 40;

const getWalletTokens = async (
  address: string,
  offset: number = 0
): Promise<{
  tokens: IOrdItem[];
  total: number;
}> => {
  const { data } = await APIClient.get(`/wallets/tokens`, {
    params: {
      ownerAddress: [address],
      limit: LIMIT,
      offset,
    },
  });

  return data;
};

export const useTokensByWallet = () => {
  const { ordinalsAddress, multiSigWallet } = useWalletContext();

  return useInfiniteQuery(
    ["wallet-tokens", ordinalsAddress, multiSigWallet.data?.address],
    {
      queryFn: async ({
        pageParam = {
          ordinalsOffset: 0,
          multiSigOffset: 0,
        },
      }) => {
        const [ordinalsTokens, multiSigTokens] = await Promise.all([
          getWalletTokens(ordinalsAddress!, pageParam.ordinalsOffset),
          getWalletTokens(
            multiSigWallet.data!.address,
            pageParam.multiSigOffset
          ),
        ]);

        return {
          tokens: ordinalsTokens.tokens.concat(multiSigTokens.tokens),
          pageParam: {
            ordinalsOffset: pageParam.ordinalsOffset + LIMIT,
            multiSigOffset: pageParam.ordinalsOffset + LIMIT,
          },
        };
      },
      enabled: !!ordinalsAddress && !!multiSigWallet.data?.address,
      getNextPageParam: (lastPage) => {
        return lastPage.pageParam;
      },
    }
  );
};
